import 'react';
import { css } from 'styled-components';
import styledTheming from '../../node_modules/styled-theming/index.js';
import '../../App.css.js';
var fontEuclidLight = "EuclidCircularA-Light, Arial;";
var fontEuclidRegular = "EuclidCircularA-Regular, Arial;";
var fontEuclidMedium = "EuclidCircularA-Medium, Arial;";
var fontEuclidSemibold = "EuclidCircularA-Semibold, Arial;";
var fontEuclidBold = "EuclidCircularA-Bold, Arial;";
var fontGraphikLight = "Graphik-Light, Arial;";
var fontGraphikRegular = "Graphik-Regular, Arial;";
var fontGraphikMedium = "Graphik-Medium, Arial;";
var fontGraphikSemibold = "Graphik-Semibold, Arial;";
var fontGraphikBold = "Graphik-Bold, Arial;";
var fontRobotoLight = "Roboto, Arial;";
var fontRobotoRegular = "Roboto, Arial;";
var fontRobotoMedium = "Roboto, Arial;";
var fontRobotoBold = "Roboto, Arial;";
var fontStolzlLight = "stolzl, Arial;";
var fontStolzlRegular = "stolzl, Arial;";
var fontStolzlMedium = "stolzl, Arial;";
var fontStolzlBold = "stolzl, Arial;";
var fontSizeTextTitle = css(["120px"]);
var fontSizeTextTitleMobile = css(["48px"]);
var fontSizeTextSubtitle = css(["96px"]);
var fontSizeTextSubtitleMobile = css(["36px"]);
var fontSizeTextTitleCaption = css(["44px"]);
var fontSizeTextTitleCaptionMobile = css(["24px"]);
var fontSizeTextCaption = css(["24px"]);
var fontSizeTextCaptionMobile = css(["16px"]);
var fontSizeTextDefault = css(["16px"]);
var fontSizeTextDefaultMobile = css(["16px"]);
css(["transition:0.3s;"]);
var textSettingsEuclidDisplay = styledTheming.variants("layout", "fontSize", {
  xxlarge: {
    light: css(["font-family:", ";font-weight:700;font-size:136px;line-height:156px;"], fontEuclidBold),
    dark: css(["font-family:", ";font-weight:700;font-size:136px;line-height:156px;"], fontEuclidBold)
  },
  xlarge: {
    light: css(["font-family:", ";font-weight:700;font-size:120px;line-height:136px;"], fontEuclidBold),
    dark: css(["font-family:", ";font-weight:700;font-size:120px;line-height:136px;"], fontEuclidBold)
  },
  large: {
    light: css(["font-family:", ";font-weight:700;font-size:96px;line-height:110px;"], fontEuclidBold),
    dark: css(["font-family:", ";font-weight:700;font-size:96px;line-height:110px;"], fontEuclidBold)
  },
  medium: {
    light: css(["font-family:", ";font-weight:700;font-size:64px;line-height:77px;"], fontEuclidBold),
    dark: css(["font-family:", ";font-weight:700;font-size:64px;line-height:77px;"], fontEuclidBold)
  },
  small: {
    light: css(["font-family:", ";font-weight:700;font-size:56px;line-height:67px;"], fontEuclidBold),
    dark: css(["font-family:", ";font-weight:700;font-size:56px;line-height:67px;"], fontEuclidBold)
  },
  xsmall: {
    light: css(["font-family:", ";font-weight:700;font-size:48px;line-height:57px;"], fontEuclidBold),
    dark: css(["font-family:", ";font-weight:700;font-size:48px;line-height:57px;"], fontEuclidBold)
  }
});
var textSettingsEuclidHeading = styledTheming.variants("layout", "fontSize", {
  xxlarge: {
    light: css(["font-family:", ";font-weight:700;font-size:40px;line-height:52px;"], fontEuclidBold),
    dark: css(["font-family:", ";font-weight:700;font-size:40px;line-height:52px;"], fontEuclidBold)
  },
  xlarge: {
    light: css(["font-family:", ";font-weight:700;font-size:34px;line-height:44px;"], fontEuclidBold),
    dark: css(["font-family:", ";font-weight:700;font-size:34px;line-height:44px;"], fontEuclidBold)
  },
  xlargeM: {
    light: css(["font-family:", ";font-weight:500;font-size:34px;line-height:44px;"], fontEuclidMedium),
    dark: css(["font-family:", ";font-weight:500;font-size:34px;line-height:44px;"], fontEuclidMedium)
  },
  large: {
    light: css(["font-family:", ";font-weight:700;font-size:28px;line-height:36px;"], fontEuclidBold),
    dark: css(["font-family:", ";font-weight:700;font-size:28px;line-height:36px;"], fontEuclidBold)
  },
  medium: {
    light: css(["font-family:", ";font-weight:700;font-size:24px;line-height:32px;"], fontEuclidBold),
    dark: css(["font-family:", ";font-weight:700;font-size:24px;line-height:32px;"], fontEuclidBold)
  },
  mediumM: {
    light: css(["font-family:", ";font-weight:500;font-size:24px;line-height:32px;"], fontEuclidMedium),
    dark: css(["font-family:", ";font-weight:500;font-size:24px;line-height:32px;"], fontEuclidMedium)
  },
  small: {
    light: css(["font-family:", ";font-weight:700;font-size:20px;line-height:28px;"], fontEuclidBold),
    dark: css(["font-family:", ";font-weight:700;font-size:20px;line-height:28px;"], fontEuclidBold)
  },
  smallM: {
    light: css(["font-family:", ";font-weight:500;font-size:20px;line-height:28px;"], fontEuclidMedium),
    dark: css(["font-family:", ";font-weight:500;font-size:20px;line-height:28px;"], fontEuclidMedium)
  }
});
var textSettingsEuclidLabel = styledTheming.variants("layout", "fontSize", {
  xxlarge: {
    light: css(["font-family:", ";font-weight:600;font-size:24px;line-height:32px;"], fontEuclidSemibold),
    dark: css(["font-family:", ";font-weight:600;font-size:24px;line-height:32px;"], fontEuclidSemibold)
  },
  xlarge: {
    light: css(["font-family:", ";font-weight:600;font-size:20px;line-height:26px;"], fontEuclidSemibold),
    dark: css(["font-family:", ";font-weight:600;font-size:20px;line-height:26px;"], fontEuclidSemibold)
  },
  largeB: {
    light: css(["font-family:", ";font-weight:700;font-size:16px;line-height:20px;"], fontEuclidBold),
    dark: css(["font-family:", ";font-weight:700;font-size:16px;line-height:20px;"], fontEuclidBold)
  },
  large: {
    light: css(["font-family:", ";font-weight:600;font-size:16px;line-height:20px;"], fontEuclidSemibold),
    dark: css(["font-family:", ";font-weight:600;font-size:16px;line-height:20px;"], fontEuclidSemibold)
  },
  medium: {
    light: css(["font-family:", ";font-weight:600;font-size:14px;line-height:16px;"], fontEuclidSemibold),
    dark: css(["font-family:", ";font-weight:600;font-size:14px;line-height:16px;"], fontEuclidSemibold)
  },
  small: {
    light: css(["font-family:", ";font-weight:600;font-size:12px;line-height:16px;"], fontEuclidSemibold),
    dark: css(["font-family:", ";font-weight:600;font-size:12px;line-height:16px;"], fontEuclidSemibold)
  }
});
var textSettingsEuclidParagraph = styledTheming.variants("layout", "fontSize", {
  xxlarge: {
    light: css(["font-family:", ";font-weight:600;font-size:24px;line-height:31px;"], fontEuclidSemibold),
    dark: css(["font-family:", ";font-weight:600;font-size:24px;line-height:31px;"], fontEuclidSemibold)
  },
  xxlargeM: {
    light: css(["font-family:", ";font-weight:500;font-size:24px;line-height:31px;"], fontEuclidMedium),
    dark: css(["font-family:", ";font-weight:500;font-size:24px;line-height:31px;"], fontEuclidMedium)
  },
  xlarge: {
    light: css(["font-family:", ";font-weight:400;font-size:24px;line-height:31px;"], fontEuclidRegular),
    dark: css(["font-family:", ";font-weight:400;font-size:24px;line-height:31px;"], fontEuclidRegular)
  },
  largeM: {
    light: css(["font-family:", ";font-weight:500;font-size:20px;line-height:27px;"], fontEuclidMedium),
    dark: css(["font-family:", ";font-weight:500;font-size:20px;line-height:27px;"], fontEuclidMedium)
  },
  large: {
    light: css(["font-family:", ";font-weight:400;font-size:20px;line-height:27px;"], fontEuclidRegular),
    dark: css(["font-family:", ";font-weight:400;font-size:20px;line-height:27px;"], fontEuclidRegular)
  },
  medium: {
    light: css(["font-family:", ";font-weight:400;font-size:16px;line-height:22px;"], fontEuclidRegular),
    dark: css(["font-family:", ";font-weight:400;font-size:16px;line-height:22px;"], fontEuclidRegular)
  },
  smallM: {
    light: css(["font-family:", ";font-weight:500;font-size:14px;line-height:18px;"], fontEuclidMedium),
    dark: css(["font-family:", ";font-weight:500;font-size:14px;line-height:18px;"], fontEuclidMedium)
  },
  small: {
    light: css(["font-family:", ";font-weight:400;font-size:14px;line-height:18px;"], fontEuclidRegular),
    dark: css(["font-family:", ";font-weight:400;font-size:14px;line-height:18px;"], fontEuclidRegular)
  },
  xsmall: {
    light: css(["font-family:", ";font-weight:400;font-size:12px;line-height:16px;"], fontEuclidRegular),
    dark: css(["font-family:", ";font-weight:400;font-size:12px;line-height:16px;"], fontEuclidRegular)
  }
});
var textSettingsGraphikDisplay = styledTheming.variants("layout", "fontSize", {
  xlarge: {
    light: css(["font-family:", ";font-weight:700;font-size:96px;line-height:112px;"], fontGraphikBold),
    dark: css(["font-family:", ";font-weight:700;font-size:96px;line-height:112px;"], fontGraphikBold)
  },
  large: {
    light: css(["font-family:", ";font-weight:700;font-size:64px;line-height:77px;"], fontGraphikBold),
    dark: css(["font-family:", ";font-weight:700;font-size:64px;line-height:77px;"], fontGraphikBold)
  },
  medium: {
    light: css(["font-family:", ";font-weight:700;font-size:56px;line-height:67px;"], fontGraphikBold),
    dark: css(["font-family:", ";font-weight:700;font-size:56px;line-height:67px;"], fontGraphikBold)
  },
  small: {
    light: css(["font-family:", ";font-weight:700;font-size:48px;line-height:57px;"], fontGraphikBold),
    dark: css(["font-family:", ";font-weight:700;font-size:48px;line-height:57px;"], fontGraphikBold)
  }
});
var textSettingsGraphikHeading = styledTheming.variants("layout", "fontSize", {
  xxlarge: {
    light: css(["font-family:", ";font-weight:700;font-size:40px;line-height:52px;"], fontGraphikBold),
    dark: css(["font-family:", ";font-weight:700;font-size:40px;line-height:52px;"], fontGraphikBold)
  },
  xlarge: {
    light: css(["font-family:", ";font-weight:700;font-size:34px;line-height:40px;"], fontGraphikBold),
    dark: css(["font-family:", ";font-weight:700;font-size:34px;line-height:40px;"], fontGraphikBold)
  },
  xlargeM: {
    light: css(["font-family:", ";font-weight:600;font-size:34px;line-height:40px;"], fontGraphikSemibold),
    dark: css(["font-family:", ";font-weight:600;font-size:34px;line-height:40px;"], fontGraphikSemibold)
  },
  large: {
    light: css(["font-family:", ";font-weight:700;font-size:28px;line-height:36px;"], fontGraphikBold),
    dark: css(["font-family:", ";font-weight:700;font-size:28px;line-height:36px;"], fontGraphikBold)
  },
  largeM: {
    light: css(["font-family:", ";font-weight:600;font-size:28px;line-height:36px;"], fontGraphikSemibold),
    dark: css(["font-family:", ";font-weight:600;font-size:28px;line-height:36px;"], fontGraphikSemibold)
  },
  medium: {
    light: css(["font-family:", ";font-weight:700;font-size:24px;line-height:32px;"], fontGraphikBold),
    dark: css(["font-family:", ";font-weight:700;font-size:24px;line-height:32px;"], fontGraphikBold)
  },
  small: {
    light: css(["font-family:", ";font-weight:700;font-size:20px;line-height:28px;"], fontGraphikBold),
    dark: css(["font-family:", ";font-weight:700;font-size:20px;line-height:28px;"], fontGraphikBold)
  },
  xsmall: {
    light: css(["font-family:", ";font-weight:600;font-size:18px;line-height:26px;"], fontGraphikSemibold),
    dark: css(["font-family:", ";font-weight:600;font-size:18px;line-height:26px;"], fontGraphikSemibold)
  }
});
var textSettingsGraphikLabel = styledTheming.variants("layout", "fontSize", {
  xxlarge: {
    light: css(["font-family:", ";font-weight:600;font-size:24px;line-height:32px;"], fontGraphikSemibold),
    dark: css(["font-family:", ";font-weight:600;font-size:24px;line-height:32px;"], fontGraphikSemibold)
  },
  xlarge: {
    light: css(["font-family:", ";font-weight:600;font-size:20px;line-height:28px;"], fontGraphikSemibold),
    dark: css(["font-family:", ";font-weight:600;font-size:20px;line-height:28px;"], fontGraphikSemibold)
  },
  large: {
    light: css(["font-family:", ";font-weight:600;font-size:16px;line-height:20px;"], fontGraphikSemibold),
    dark: css(["font-family:", ";font-weight:600;font-size:16px;line-height:20px;"], fontGraphikSemibold)
  },
  medium: {
    light: css(["font-family:", ";font-weight:600;font-size:14px;line-height:16px;"], fontGraphikSemibold),
    dark: css(["font-family:", ";font-weight:600;font-size:14px;line-height:16px;"], fontGraphikSemibold)
  },
  small: {
    light: css(["font-family:", ";font-weight:600;font-size:12px;line-height:16px;"], fontGraphikSemibold),
    dark: css(["font-family:", ";font-weight:600;font-size:12px;line-height:16px;"], fontGraphikSemibold)
  },
  smallM: {
    light: css(["font-family:", ";font-weight:500;font-size:12px;line-height:16px;"], fontGraphikSemibold),
    dark: css(["font-family:", ";font-weight:500;font-size:12px;line-height:16px;"], fontGraphikSemibold)
  }
});
var textSettingsGraphikParagraph = styledTheming.variants("layout", "fontSize", {
  xlargeM: {
    light: css(["font-family:", ";font-weight:500;font-size:24px;line-height:30px;"], fontGraphikMedium),
    dark: css(["font-family:", ";font-weight:400;font-size:24px;line-height:30px;"], fontGraphikRegular)
  },
  large: {
    light: css(["font-family:", ";font-weight:400;font-size:20px;line-height:22px;"], fontGraphikRegular),
    dark: css(["font-family:", ";font-weight:400;font-size:20px;line-height:22px;"], fontGraphikRegular)
  },
  medium: {
    light: css(["font-family:", ";font-weight:400;font-size:16px;line-height:22px;"], fontGraphikRegular),
    dark: css(["font-family:", ";font-weight:400;font-size:16px;line-height:22px;"], fontGraphikRegular)
  },
  mediumM: {
    light: css(["font-family:", ";font-weight:500;font-size:16px;line-height:22px;"], fontGraphikMedium),
    dark: css(["font-family:", ";font-weight:500;font-size:16px;line-height:22px;"], fontGraphikMedium)
  },
  smallM: {
    light: css(["font-family:", ";font-weight:500;font-size:14px;line-height:20px;"], fontGraphikMedium),
    dark: css(["font-family:", ";font-weight:500;font-size:14px;line-height:20px;"], fontGraphikMedium)
  },
  small: {
    light: css(["font-family:", ";font-weight:400;font-size:14px;line-height:20px;"], fontGraphikRegular),
    dark: css(["font-family:", ";font-weight:400;font-size:14px;line-height:20px;"], fontGraphikRegular)
  },
  xsmall: {
    light: css(["font-family:", ";font-weight:400;font-size:12px;line-height:16px;"], fontGraphikRegular),
    dark: css(["font-family:", ";font-weight:400;font-size:12px;line-height:16px;"], fontGraphikRegular)
  }
});
var textSettingsEuclid = styledTheming.variants("layout", "type", {
  display: {
    light: css(["", ""], textSettingsEuclidDisplay),
    dark: css(["", ""], textSettingsEuclidDisplay)
  },
  heading: {
    light: css(["", ""], textSettingsEuclidHeading),
    dark: css(["", ""], textSettingsEuclidHeading)
  },
  label: {
    light: css(["", ""], textSettingsEuclidLabel),
    dark: css(["", ""], textSettingsEuclidLabel)
  },
  paragraph: {
    light: css(["", ""], textSettingsEuclidParagraph),
    dark: css(["", ""], textSettingsEuclidParagraph)
  }
});
var textSettingsGraphik = styledTheming.variants("layout", "type", {
  display: {
    light: css(["", ""], textSettingsGraphikDisplay),
    dark: css(["", ""], textSettingsGraphikDisplay)
  },
  heading: {
    light: css(["", ""], textSettingsGraphikHeading),
    dark: css(["", ""], textSettingsGraphikHeading)
  },
  label: {
    light: css(["", ""], textSettingsGraphikLabel),
    dark: css(["", ""], textSettingsGraphikLabel)
  },
  paragraph: {
    light: css(["", ""], textSettingsGraphikParagraph),
    dark: css(["", ""], textSettingsGraphikParagraph)
  }
});
var textSettings = styledTheming.variants("layout", "fontFamily", {
  euclid: {
    light: css(["", ""], textSettingsEuclid),
    dark: css(["", ""], textSettingsEuclid)
  },
  graphik: {
    light: css(["", ""], textSettingsGraphik),
    dark: css(["", ""], textSettingsGraphik)
  }
});
var fontSettingsEuclid = styledTheming.variants("layout", "fontWeight", {
  light: {
    light: css(["font-family:", ";font-weight:300;"], fontEuclidLight),
    dark: css(["font-family:", ";font-weight:300;"], fontEuclidLight)
  },
  regular: {
    light: css(["font-family:", ";font-weight:400;"], fontEuclidRegular),
    dark: css(["font-family:", ";font-weight:400;"], fontEuclidRegular)
  },
  medium: {
    light: css(["font-family:", ";font-weight:500;"], fontEuclidMedium),
    dark: css(["font-family:", ";font-weight:500;"], fontEuclidMedium)
  },
  semibold: {
    light: css(["font-family:", ";font-weight:600;"], fontEuclidSemibold),
    dark: css(["font-family:", ";font-weight:600;"], fontEuclidSemibold)
  },
  bold: {
    light: css(["font-family:", ";font-weight:700;"], fontEuclidBold),
    dark: css(["font-family:", ";font-weight:700;"], fontEuclidBold)
  }
});
var fontSettingsGraphik = styledTheming.variants("layout", "fontWeight", {
  light: {
    light: css(["font-family:", ";font-weight:300;"], fontGraphikLight),
    dark: css(["font-family:", ";font-weight:300;"], fontGraphikLight)
  },
  regular: {
    light: css(["font-family:", ";font-weight:400;"], fontGraphikRegular),
    dark: css(["font-family:", ";font-weight:400;"], fontGraphikRegular)
  },
  medium: {
    light: css(["font-family:", ";font-weight:500;"], fontGraphikMedium),
    dark: css(["font-family:", ";font-weight:500;"], fontGraphikMedium)
  },
  semibold: {
    light: css(["font-family:", ";font-weight:600;"], fontGraphikSemibold),
    dark: css(["font-family:", ";font-weight:600;"], fontGraphikSemibold)
  },
  bold: {
    light: css(["font-family:", ";font-weight:700;"], fontGraphikBold),
    dark: css(["font-family:", ";font-weight:700;"], fontGraphikBold)
  }
});
var fontSettings = styledTheming.variants("layout", "fontFamily", {
  euclid: {
    light: css(["", ""], fontSettingsEuclid),
    dark: css(["", ""], fontSettingsEuclid)
  },
  graphik: {
    light: css(["", ""], fontSettingsGraphik),
    dark: css(["", ""], fontSettingsGraphik)
  }
});
export { fontEuclidBold, fontEuclidLight, fontEuclidMedium, fontEuclidRegular, fontEuclidSemibold, fontGraphikBold, fontGraphikLight, fontGraphikMedium, fontGraphikRegular, fontGraphikSemibold, fontRobotoBold, fontRobotoLight, fontRobotoMedium, fontRobotoRegular, fontSettings, fontSettingsEuclid, fontSettingsGraphik, fontSizeTextCaption, fontSizeTextCaptionMobile, fontSizeTextDefault, fontSizeTextDefaultMobile, fontSizeTextSubtitle, fontSizeTextSubtitleMobile, fontSizeTextTitle, fontSizeTextTitleCaption, fontSizeTextTitleCaptionMobile, fontSizeTextTitleMobile, fontStolzlBold, fontStolzlLight, fontStolzlMedium, fontStolzlRegular, textSettings, textSettingsEuclid, textSettingsEuclidDisplay, textSettingsEuclidHeading, textSettingsEuclidLabel, textSettingsEuclidParagraph, textSettingsGraphik, textSettingsGraphikDisplay, textSettingsGraphikHeading, textSettingsGraphikLabel, textSettingsGraphikParagraph };